@use 'ui/styles/core-tokens' as core;

.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 145px);
}
